export class CustomResponseError extends Error {
	type: string;
	data: any;
	status: number;
	statusText: string;
	innerError: Error;
	constructor(errorInfo: JsonErrorInfo, status: number, statusText: string, innerError?: Error) {
		super(errorInfo.Message);
		this.type = errorInfo.Type;
		this.data = errorInfo.Data;
		this.status = status;
		this.statusText = statusText;
		this.innerError = innerError;
	}
}

export type JsonErrorInfo = {
	Type?: string;
	Message?: string;
	Data?: any;
}